<template>
  <div class="message-file" @click="handleDownload">
    <div class="message-file__info">
      <div class="message-file__name">{{ title }}</div>
      <div v-if="size" class="message-file__size">{{ size }}</div>
    </div>
    <div class="message-file__icon" :class="fileType"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      title: '',
      url: '',
      size: ''
    })
  }
})

const FileTypeMap = {
  xls: 'excel',
  xlsx: 'excel',
  html: 'html',
  htm: 'html',
  jpg: 'image',
  jpeg: 'image',
  git: 'image',
  png: 'image',
  pdf: 'pdf',
  doc: 'word',
  docx: 'word',
  txt: 'text',
  zip: 'zip',
  '*': 'other'
}

const getFileType = (name = '') => {
  const strArr = name.split('.')
  const suffix = strArr[strArr.length - 1]
  console.log('🚀 ~ getFileType ~ suffix:', suffix)
  return FileTypeMap[suffix] || FileTypeMap['*']
}

const title = computed(() => props.message.title || '')
const size = computed(() => props.message.size || '')
const fileType = computed(() => getFileType(title.value))

const handleDownload = () => {
  const fileUrl = props.message.url
  if (!fileUrl) {
    ElMessage.error('未找到下载链接')
    return
  }

  const link = document.createElement('a')
  link.href = fileUrl
  link.download = title.value || '文件'
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>

<style lang="scss" scoped>
.message-file {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  width: 240px;
  min-height: 62px;
  padding: 12px;
  color: #323233;
  background: #fff;
  border: 1px solid #f2f3f5;
  cursor: pointer;
}

.message-file__info {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  margin-right: 8px;
}

.message-file__name {
  display: -webkit-box;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.message-file__size {
  margin-top: 4px;
  overflow: hidden;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #969799;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-file__icon {
  flex: none;
  width: 38px;
  height: 38px;

  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;

  &.other {
    background-image: url('@/assets/file-icon/ic_file_other.png');
  }
  &.image {
    background-image: url('@/assets/file-icon/ic_file_image.png');
  }
  &.text {
    background-image: url('@/assets/file-icon/ic_file_text.png');
  }
  &.zip {
    background-image: url('@/assets/file-icon/ic_file_zip.png');
  }
  &.sounds {
    background-image: url('@/assets/file-icon/ic_file_sounds.png');
  }
  &.excel {
    background-image: url('@/assets/file-icon/ic_file_excel.png');
  }
  &.pdf {
    background-image: url('@/assets/file-icon/ic_file_pdf.png');
  }
  &.word {
    background-image: url('@/assets/file-icon/ic_file_word.png');
  }
  &.ppt {
    background-image: url('@/assets/file-icon/ic_file_ppt.png');
  }
  &.video {
    background-image: url('@/assets/file-icon/ic_file_video.png');
  }
  &.html {
    background-image: url('@/assets/file-icon/ic_file_html.png');
  }
}
</style>
